function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { FunctionalLoader, Toast } from 'seagull';
import React, { useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Callout, ConfirmationModal, GridItem, Spinner, TextField, Typography, useStateInRef } from 'seagull';
import { defaultAgreementTitle, howToEditAgreementUrl, routes } from "../../constants";
import { useEventReporter, useGlobalContext, useIoContext, useStore, useStoreActions } from "../../contexts";
import { handleRequest, sendErrReport, wait } from "../../infra/utils";
import { contactModel, serviceModel, timeModel } from "../../models";
import { AgreementName } from "./AgreementName";
import { contactHasAgreement, getCreateRelationshipError } from "./AgreementStudio.utils";
import AgreementStudioWithLegalTermsModal from "./AgreementStudioWithLegalTermsModal";
import { ClientPreview } from "./ClientPreview";
import { useCopyAgreementLink } from "../../hooks/useCopyAgreementLink";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { makeNetTerms } from "../../infra/translator";
import { PostAgreementCreation } from "./PostAgreementCreation";
import { Checkmark, TrashLine } from 'seagull/icons';
import DatePickerPanel from "./DatePickerPanel";
import { Intent } from "../../infra/access-control";
import ContactDetails from "./ContactDetails/ContactDetails";
import ExternalLinkButton from "../ExternalLinkButton";
import styles from "./AgreementStudio.module.scss";
const createRelationshipLoader = 'createRelationship';
export function AgreementStudioProposalMode(props) {
  var _props$relationshipDr, _ref, _relationshipDraft$is;

  const relationshipDraft = props.relationshipDraft;
  const {
    reportFormSubmission,
    reportToAppcues,
    reportToGtm,
    reportToHubspot,
    reportToHeap
  } = useEventReporter();
  const history = useHistory();
  const {
    prepareFormObject,
    reportProductsFormSubmission,
    reportButtonClick
  } = useEventReporter();
  const {
    api,
    fetchContacts,
    setWorksAt,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const agreements = useStore(state => state.agreements.data);
  const proposals = useStore(state => state.proposals.data);
  const scrollToTopRef = useRef(null);
  const [newContactValid, setNewContactValid] = useState(true);
  const [firstName, setFirstName] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerFirstName) || '');
  const [lastName, setLastName] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerLastName) || '');
  const [companyName, setCompanyName] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.customerName) || '');
  const [email, setEmail] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerEmail) || '');
  const [phone, setPhoneNumber] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerPhone) || null);
  const [titleValid, setTitleValid] = useState(((_props$relationshipDr = props.relationshipDraft) === null || _props$relationshipDr === void 0 ? void 0 : _props$relationshipDr.title) != null);
  const [clientContactId, setClientContactId] = useState(relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.clientContactId);
  const [showAgreementTitleWarning, setShowAgreementTitleWarning] = useState(false);
  const locationState = useLocation().state;
  const [isSampleRelationship, setIsSampleRelationship] = useState((_ref = (_relationshipDraft$is = relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.isSample) !== null && _relationshipDraft$is !== void 0 ? _relationshipDraft$is : locationState === null || locationState === void 0 ? void 0 : locationState.defaultToSampleContact) !== null && _ref !== void 0 ? _ref : false);
  const [effectiveDate, setEffectiveDate] = useState(() => relationshipDraft !== null && relationshipDraft !== void 0 && relationshipDraft.effectiveDate ? timeModel.fromDatestampObject(relationshipDraft.effectiveDate) : null);
  const [showCustomerDetailsWarning, setShowCustomerDetailsWarning] = useState(false);
  const [draftId, setDraftId] = useState(relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.id);
  const getDraftId = useStateInRef(draftId);
  const {
    getNow
  } = useIoContext();
  const contacts = useStore(state => state.contacts);
  const [contactsMap, sampleContact] = useMemo(() => {
    var _contacts$data;

    const contactsData = (_contacts$data = contacts.data) !== null && _contacts$data !== void 0 ? _contacts$data : [];
    const contactsMap = {};
    let sampleContact = contactModel.makeSampleContact({
      createdAt: getNow(),
      vendorId: props.worksAt.id
    });

    for (let i = 0; i < contactsData.length; i++) {
      const contact = contactsData[i];

      if (contact.isSample) {
        sampleContact = contact;
      } else {
        contactsMap[contact.id] = contact;
      }
    }

    return [contactsMap, sampleContact];
  }, [contacts, props.worksAt.id]);
  const isSavingDraft = useRef(false);
  const [draftStatus, setDraftStatus] = useState(null);
  const existingContact = clientContactId ? contactsMap[clientContactId] : isSampleRelationship ? sampleContact : undefined;
  const [agreementTitle, setAgreementTitle] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.title) || defaultAgreementTitle); //the 'edit' is for backwards compatibility - changing the terminology. This could probably be deleted shortly

  const isDraftOriginatedAsEdit = !!relationshipDraft && ['withdraw-to-edit', 'edit'].includes(relationshipDraft.creationStrategy);

  const showAgreementCreationToast = () => globalContext.showSuccessToast('Agreement was sent successfully');

  const navigationAfterCreation = redirectUrl => {
    const url = redirectUrl || routes.proposalsDashboard;
    history.push(url);

    if (url === routes.agreementStudio) {
      history.go(0);
    }
  };

  const {
    getAgreementNotificationLink
  } = useCopyAgreementLink();

  const toCommonWithId = draft => ({
    id: generateUniqueId('proposal-template'),
    coverLetter: draft.coverLetter,
    extraClause: draft.extraClause,
    requirePaymentMethod: draft.requirePaymentMethod,
    allowManualPayments: draft.allowManualPayments,
    isExistingCustomer: draft.isExistingCustomer,
    customNotificationText: draft.customNotificationText,
    services: draft.services,
    serviceBundles: draft.serviceBundles,
    netTerms: draft.netTerms,
    legalTerms: draft.legalTerms,
    coverCreditCardFees: draft.feeControls.coverCreditCardFees,

    /** Will automatic ongoing services be billed at the start or end of the billing-period. */
    amendmentsApprovalMethod: draft.amendmentsApprovalMethod,
    requestAccountantAccess: draft.requestAccountantAccess
  });

  const discardDraft = async () => {
    const loaderName = 'discardDraft';
    globalContext.startLoader(loaderName);

    try {
      await api.draft.deleteById(draftId);
      history.push(routes.draftsDashboard);
    } finally {
      globalContext.stopLoader(loaderName);
    }
  };

  const getDraft = function getDraft(data) {
    var _data$isExistingCusto, _data$serviceBundles;

    let id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : draftId !== null && draftId !== void 0 ? draftId : '';

    function serviceToDTO(s) {
      return serviceModel.toDTO(s);
    }

    return {
      id,
      title: agreementTitle,
      buyerFirstName: firstName,
      buyerLastName: lastName,
      buyerEmail: email,
      buyerPhone: phone,
      customerName: companyName,
      clientContactId: clientContactId !== null && clientContactId !== void 0 ? clientContactId : null,
      isSample: isSampleRelationship,
      lastModifiedOn: Date.now(),
      extraClause: data.extraClause,
      requirePaymentMethod: data.requirePaymentMethod,
      allowManualPayments: data.allowManualPayments,
      customNotificationText: data.customNotificationText,
      creationStrategy: null,
      isExistingCustomer: (_data$isExistingCusto = data.isExistingCustomer) !== null && _data$isExistingCusto !== void 0 ? _data$isExistingCusto : false,
      netTerms: data.netTerms,
      effectiveDate: effectiveDate ? timeModel.toDatestampObject(effectiveDate) : null,
      coverLetter: data.coverLetter,
      feeControls: {
        coverCreditCardFees: data.coverCreditCardFees,
        coverDirectDebitFees: false
      },
      legalTerms: data.legalTerms,
      services: data.services.map(serviceToDTO),
      serviceBundles: (_data$serviceBundles = data.serviceBundles) !== null && _data$serviceBundles !== void 0 && _data$serviceBundles.bundles.length ? {
        bundles: data.serviceBundles.bundles.map(b => _objectSpread(_objectSpread({}, b), {}, {
          services: b.services.map(serviceToDTO)
        }))
      } : undefined,
      amendmentsApprovalMethod: data.amendmentsApprovalMethod,
      requestAccountantAccess: data.requestAccountantAccess
    };
  };

  const genDraftId = () => {
    if (draftId) {
      return draftId;
    } else {
      const id = generateUniqueId('draft');
      setDraftId(id);
      window.history.replaceState('', 'Draft', routes.draft(id));
      return id;
    }
  };

  const saveDraft = async (data, isMounted) => {
    reportFormSubmission('agreement-studio-mandatory-fields', [prepareFormObject('agreement-studio-mandatory-fields-first-name', firstName), prepareFormObject('agreement-studio-mandatory-fields-last-name', lastName), prepareFormObject('agreement-studio-mandatory-fields-company-name', companyName), prepareFormObject('agreement-studio-mandatory-fields-email-address', email)]);

    if (!isMounted()) {
      return;
    }

    isSavingDraft.current = true;
    const id = genDraftId();
    setDraftStatus('loading');

    try {
      var _data$legalTerms;

      const invalidLegalTerms = ((_data$legalTerms = data.legalTerms) === null || _data$legalTerms === void 0 ? void 0 : _data$legalTerms.type) === 'pdf' && !data.legalTerms.pdfUniqueName;

      if (!invalidLegalTerms) {
        await api.draft.save(getDraft(data, id));
      }

      if (isMounted()) {
        isSavingDraft.current = false;
        setDraftStatus('saved');
      }
    } catch (err) {
      if (isMounted()) {
        isSavingDraft.current = false;
      }
    }
  };

  const onSubmit = async data => {
    var _props$worksAt$key;

    reportButtonClick('agreement-studio-topbar-btn-submit');
    logBI(10485);
    let finalFirstName = firstName;
    let finalLastName = lastName;
    let finalCompanyName = companyName;
    let finalEmail = email;

    if (clientContactId && existingContact) {
      finalFirstName = existingContact.firstName;
      finalLastName = existingContact.lastName;
      finalCompanyName = existingContact.companyName;
      finalEmail = existingContact.email;
    }

    if (isSampleRelationship) {
      finalFirstName = sampleContact.firstName;
      finalLastName = sampleContact.lastName;
      finalCompanyName = sampleContact.companyName;
      finalEmail = sampleContact.email;
    } // First things first: validate stuff!


    if (!newContactValid || !finalFirstName || finalFirstName.length < 2 || !finalLastName || finalLastName.length < 2 || !finalCompanyName) {
      if (scrollToTopRef.current != null) scrollToTopRef.current();
      setShowCustomerDetailsWarning(true);
      return;
    }

    if (!titleValid) {
      setShowAgreementTitleWarning(true);
      return;
    }

    const shouldSendAgreement = await globalContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(ConfirmationModal, {
          title: "Ready to send?",
          "data-testid": "send-proposal-modal",
          content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, "You\u2019re about to send a proposal to:"), /*#__PURE__*/React.createElement(Typography, null, "".concat(finalCompanyName, " (").concat(finalFirstName, " ").concat(finalLastName, " - ").concat(finalEmail, ")"))),
          textAlignCenter: false,
          onPrimaryButtonClick: () => dismissModal(true),
          onSecondaryButtonClick: () => dismissModal(false),
          primaryButtonLabel: "Send now",
          secondaryButtonLabel: "Back"
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    });
    if (!shouldSendAgreement) return;

    if (isSampleRelationship) {
      logBI(11901);
      reportToGtm('form-success', 'vendor-sent-test-agreement');
      reportToAppcues('form-success', 'vendor-sent-test-agreement');
      reportToHeap('testAgreement', 'submit', 'vendor-sent-test-agreement');
      reportToHubspot('vendor_sent_a_test_agreement');
    } else {
      logBI(10479, {
        clientEmail: finalEmail,
        selectedDay: undefined
      });
      reportProductsFormSubmission('send-agreement-for-approval', [prepareFormObject('buyerName', {
        first: finalFirstName,
        last: finalLastName
      }), prepareFormObject('buyerEmail', finalEmail), prepareFormObject('customerName', finalCompanyName), prepareFormObject('serviceCount', data.services.length), prepareFormObject('netTerms', makeNetTerms(data.netTerms)), prepareFormObject('isExistingCustomer', data.isExistingCustomer)]);
    }

    globalContext.startLoader(createRelationshipLoader); // To avoid a race-condition, don't allow to create a relationship while we're saving a draft

    while (isSavingDraft.current) {
      await wait(300);
    }

    const [relationshipId, err, hasError] = await handleRequest(api.relationship.createFromDraft(getDraftId()));

    if (hasError) {
      sendErrReport('an error occurred while creating a proposal', err);
      const {
        text
      } = getCreateRelationshipError(err);
      globalContext.showErrorToast(text);
      saveDraft(data, () => true);
      globalContext.stopLoader(createRelationshipLoader);
      return;
    }

    const key = isSampleRelationship ? 'numSampleAgreements' : 'numSaleAgreements';
    const {
      pending,
      approved
    } = (_props$worksAt$key = props.worksAt[key]) !== null && _props$worksAt$key !== void 0 ? _props$worksAt$key : {
      pending: 0,
      approved: 0
    };
    setWorksAt(_objectSpread(_objectSpread({}, props.worksAt), {}, {
      [key]: {
        pending: pending + 1,
        approved
      }
    }));

    if (!isSampleRelationship && pending === 0 && approved === 0) {
      // Important note: this event should be sent from the backend, as we can't assure that the "worksAt" is correct.
      // It is a technical gap.
      reportToGtm('form-success', 'user-successfully-sent-first-agreement');
      reportToAppcues('form-success', 'user-successfully-sent-first-agreement');
      reportToHubspot('user_successfully_sent_first_agreement_');
      reportToHeap('agreementStudio', 'submit', 'user-successfully-sent-first-agreement');
    }

    globalContext.stopLoader(createRelationshipLoader);

    try {
      const notificationLink = await getAgreementNotificationLink(relationshipId);
      const redirectUrl = await globalContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref3 => {
          let {
            dismissModal
          } = _ref3;
          return /*#__PURE__*/React.createElement(PostAgreementCreation, {
            relationshipId: relationshipId,
            testId: "agreement-studio-post-creation-modal",
            linkUrl: notificationLink,
            onClose: dismissModal,
            name: "".concat(finalFirstName, " ").concat(finalLastName),
            sampleAgreementData: isSampleRelationship ? {
              email: props.userEmail
            } : undefined
          });
        }
      });
      navigationAfterCreation(redirectUrl);
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      sendErrReport('failed to show success modal', error);
      showAgreementCreationToast(); //fail silently in a reasonable way

      navigationAfterCreation();
    }
  };

  const openPreviewModal = data => {
    const draft = getDraft(data, getDraftId());
    reportButtonClick('agreement-previewed-agreement');
    if (!legalTermsDocuments) return;
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref4 => {
        let {
          dismissModal
        } = _ref4;
        return /*#__PURE__*/React.createElement(ClientPreview, {
          draft: draft,
          contactsMap: contactsMap,
          sampleContact: sampleContact,
          legalTerms: legalTermsDocuments,
          dismissModal: dismissModal
        });
      }
    });
  };

  const saveAsTemplate = async () => {
    if (draftId != null) {
      const name = await globalContext.showModal({
        content: function RenameModal(_ref5) {
          let {
            dismissModal
          } = _ref5;
          const [name, setName] = useState('');
          return /*#__PURE__*/React.createElement(ConfirmationModal, {
            title: "Save as template",
            "data-testid": "save-as-proposal-template-modal",
            content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
              testid: "proposal-template-name",
              name: "templateName",
              label: "Template name",
              value: name,
              onChange: e => {
                setName(e.target.value);
              },
              autoFocus: true
            }), /*#__PURE__*/React.createElement(Callout, {
              style: {
                marginTop: '32px'
              }
            }, "Your template can be managed and used through the \"Proposal Templates\" page.")),
            primaryButtonLabel: "Save",
            onPrimaryButtonClick: () => dismissModal(name),
            secondaryButtonLabel: "Cancel",
            onSecondaryButtonClick: () => dismissModal(null),
            onCloseButtonClick: () => dismissModal(null)
          });
        }
      });

      if (name) {
        api.proposalTemplates.createFromDraft(draftId, name).then(() => {
          history.push(routes.proposalTemplates);
        }).then(() => {
          globalContext.showToast( /*#__PURE__*/React.createElement(Toast, {
            testid: "proposal-template-saved-toast",
            type: "success",
            text: "Proposal template successfully saved"
          }));
        }, e => {
          var _error$response, _error$response$data;

          const error = e;

          if (((_error$response = error.response) === null || _error$response === void 0 ? void 0 : (_error$response$data = _error$response.data) === null || _error$response$data === void 0 ? void 0 : _error$response$data.error) === 'NAME_ALREADY_EXISTS') {
            globalContext.showToast( /*#__PURE__*/React.createElement(Toast, {
              testid: "proposal-template-name-already-used",
              type: "error",
              text: "A template with this name already exists"
            }));
          } else {
            globalContext.showToast( /*#__PURE__*/React.createElement(Toast, {
              testid: "proposal-template-not-saved-toast",
              type: "error",
              text: "There was an error saving this template"
            }));
          }
        });
      }
    }
  };

  return legalTermsDocuments && contacts.data ? /*#__PURE__*/React.createElement(AgreementStudioWithLegalTermsModal, _extends({}, props, {
    relationshipDraft: props.relationshipDraft != null ? toCommonWithId(props.relationshipDraft) : undefined,
    isSampleRelationship: isSampleRelationship,
    modalTitle: "Create proposal",
    contact: existingContact,
    legalTermsDocuments: legalTermsDocuments,
    additionalAutoSaveDependencies: [agreementTitle, clientContactId, companyName, effectiveDate, email, firstName, lastName, phone],
    doScrollToTopRef: scrollToTopRef,
    savingStatusMP: /*#__PURE__*/React.createElement(React.Fragment, null, draftStatus === 'loading' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
      size: 24
    }), /*#__PURE__*/React.createElement(Typography, {
      role: "alert",
      as: "p"
    }, "Saving draft")), draftStatus === 'saved' && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: styles.checkmarkContainer
    }, /*#__PURE__*/React.createElement(Checkmark, null)), /*#__PURE__*/React.createElement(Typography, null, "Draft saved"))),
    agreementTitleMP: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AgreementName, {
      agreementTitle: agreementTitle,
      setAgreementTitle: setAgreementTitle,
      setAgreementTitleValid: setTitleValid,
      showWarning: showAgreementTitleWarning,
      label: "Agreement name"
    }), /*#__PURE__*/React.createElement(ContactDetails, {
      newContact: {
        firstName,
        lastName,
        companyName,
        email,
        phone,
        isSample: false
      },
      existingContact: existingContact,
      refreshExistingContacts: fetchContacts,
      onValidation: setNewContactValid,
      onChange: change => {
        setIsSampleRelationship(change.type === 'sampleContact');
        setClientContactId(change.type === 'existingContact' ? change.id : null);

        if (change.type === 'existingContact') {
          setShowCustomerDetailsWarning(false);
        } else if (change.type === 'newContact') {
          var _change$details$first, _change$details$lastN, _change$details$compa, _change$details$email;

          setFirstName((_change$details$first = change.details.firstName) !== null && _change$details$first !== void 0 ? _change$details$first : '');
          setLastName((_change$details$lastN = change.details.lastName) !== null && _change$details$lastN !== void 0 ? _change$details$lastN : '');
          setCompanyName((_change$details$compa = change.details.companyName) !== null && _change$details$compa !== void 0 ? _change$details$compa : '');
          setEmail((_change$details$email = change.details.email) !== null && _change$details$email !== void 0 ? _change$details$email : '');
          setPhoneNumber(change.details.phone || null);
          setShowCustomerDetailsWarning(false);
        } else if (change.type === 'initial') {
          setFirstName('');
          setLastName('');
          setCompanyName('');
          setEmail('');
          setPhoneNumber('');
        }
      },
      isDraftOriginatedAsEdit: isDraftOriginatedAsEdit,
      showCustomerDetailsWarning: showCustomerDetailsWarning
    }), existingContact && contactHasAgreement(existingContact, agreements, proposals) && /*#__PURE__*/React.createElement(GridItem, {
      span: 12
    }, /*#__PURE__*/React.createElement(Callout, null, "It appears you have an agreement with ", existingContact.companyName, ". To change terms, or add/edit services, edit the existing agreement instead of creating a new one.", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
      openInNewTab: true,
      href: howToEditAgreementUrl,
      testid: "agreement-studio-amendment-info"
    }, "Learn more"))), /*#__PURE__*/React.createElement(DatePickerPanel, {
      value: effectiveDate,
      onChange: setEffectiveDate,
      title: "Agreement effective date",
      description: "The date when you can start providing the services and bill the client."
    })),
    inlineFooterActions: [{
      text: 'Save as template',
      intent: Intent.CreateProposalTemplate,
      testid: 'agreement-studio-save-template',
      disabled: draftId == null,
      onClick: saveAsTemplate,
      tooltipTitle: draftId == null ? 'Make changes to your draft in order to save it as a proposal template' : undefined
    }],
    additionalFooterActions: [{
      text: 'Discard draft',
      skin: 'error',
      disabled: draftId == null,
      iconStart: /*#__PURE__*/React.createElement(TrashLine, null),
      testid: 'agreement-studio-topbar-discard-draft',
      onClick: discardDraft
    }],
    submitButtonLabel: "Send",
    submitButtonIntent: Intent.SendProposal,
    onSubmitCb: onSubmit,
    onAutoSaveCb: saveDraft,
    openPreviewModal: openPreviewModal
  })) : /*#__PURE__*/React.createElement(FunctionalLoader, {
    show: true
  });
}